import axios from "axios";

// API Base URLs
export const BASE_URL = "https://pilot.socbuddy.com/socbuddy";
export const BASE_URL_API = "https://pilot.socbuddy.com/socbuddy";
export const AUTH_BASE_URL = "https://pilot.socbuddy.com/socbuddy";

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: "/login",
  SIGNUP: "/signup",
  VERIFY_OTP: "/verify-otp",
  REFRESH_TOKEN: "/refresh-token",
  LOGOUT: "/logout",

  // Chat endpoints
  SEND_MESSAGE: "/search-triage-alerts-weaviate",
  GET_SYNC_STATUS: "/get-triage-alerts-sync-status",
  GET_NOTTIFICATION_SETTINGS: "/get-triage-alerts-notifications-settings",
  SAVE_NOTTIFICATION_SETTINGS: "/save-triage-alerts-notifications-settings",
  GET_SUGGESTIONS: "/triage-alerts-base-prompts",

  // User endpoints
  GET_PROFILE: "/user/profile",
  UPDATE_PROFILE: "/user/profile",
  GET_SETTINGS: "/user/settings",
  UPDATE_SETTINGS: "/user/settings",

  // Workout endpoints
  ADD_MINUTES: "/workout/add-minutes",
  GET_WORKOUT_HISTORY: "/workout/history",
};

// Create axios instance with default config
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 240000, // 240 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem("authToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth API instance
export const authApi = axios.create({
  baseURL: AUTH_BASE_URL,
  timeout: 240000, // 240 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Helper functions
export const apiHelper = {
  // GET request
  get: async (endpoint, params = {}) => {
    try {
      const response = await api.get(endpoint, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // POST request
  post: async (endpoint, data = {}) => {
    try {
      const response = await api.post(endpoint, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // PUT request
  put: async (endpoint, data = {}) => {
    try {
      const response = await api.put(endpoint, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // DELETE request
  delete: async (endpoint) => {
    try {
      const response = await api.delete(endpoint);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Auth POST request
  authPost: async (endpoint, data = {}) => {
    try {
      const response = await authApi.post(endpoint, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default api;
